if (!customElements.get('collection-dropdown-nav')) {
  customElements.define('collection-dropdown-nav', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const rootItems = [...this.querySelectorAll('.t4s-dropdown-nav-inner > li')];
      const branches = rootItems.map(item => item.querySelector(':scope > details')).filter(Boolean);
      const close = branch => {
        branch.open = false;
        branch.querySelectorAll('details[open]').forEach(child => { child.open = false; });
      };
      const position = branch => {
        const panel = branch.querySelector(':scope > ul');
        if (!panel || !branch.open || window.innerWidth <= 768) return;
        panel.style.setProperty('--panel-shift', '0px');
        const rect = panel.getBoundingClientRect();
        const shift = Math.max(16 - rect.left, Math.min(0, document.documentElement.clientWidth - 16 - rect.right));
        panel.style.setProperty('--panel-shift', shift + 'px');
      };
      branches.forEach(branch => {
        branch.addEventListener('toggle', () => {
          if (branch.open) {
            branches.filter(other => other !== branch).forEach(close);
            position(branch);
          }
        }, options);
        const item = branch.parentElement;
        item.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
            branch.open = true;
          }
        }, options);
        item.addEventListener('pointerleave', event => {
          if (event.pointerType === 'mouse' && !item.contains(document.activeElement)) close(branch);
        }, options);
        item.addEventListener('focusout', event => {
          if (!item.contains(event.relatedTarget)) close(branch);
        }, options);
      });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const branch = event.target.closest('details[open]') ||
          event.target.closest('li')?.querySelector(':scope > details[open]');
        if (!branch) return;
        event.preventDefault();
        event.stopPropagation();
        close(branch);
        branch.querySelector(':scope > summary').focus();
      }, options);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) branches.forEach(close);
      }, options);
      window.addEventListener('resize', () => branches.forEach(position), options);
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
